<template>
	<div class="grid__content">
        <div class="grid__navigator black-overlay">
            <scrollbar class="profile-scroll">
                <div class="profile_blockWidget profile_blockWidget_big-column">
                    <div class="profile_blockWidget-image">
                        <div class="profile_blockWidget-imageItem">
                            <a href="http://master.forexinvest.com/files/diplom_1.pdf" target="_blank">
                                <img src="../assets/img/diplom_1.png">
                            </a>
                        </div>
                        <div class="profile_blockWidget-imageItem">
                            <a href="http://master.forexinvest.com/files/diplom_2.pdf" target="_blank">
                                <img src="../assets/img/diplom_2.png">
                            </a>
                        </div>
                    </div>
                    <div class="profile_blockWidget-text">
                        <div class="profile_blockWidget-wrap">
                            <div class="profile_blockWidget-title">
                                Наши атестаты
                            </div>
                            <div class="profile_blockWidget-subtitle">
                                <a href="http://www.cbr.ru/finmarket/supervision/sv_validation/att_check/" target="_blank">
                                    Проверка статуса<br>квалифицированного атестата
                                </a>
                            </div>
                        </div>
                        <div class="profile_blockWidget-ico">
							<svg-icon icon-class="icon icon--inline mt-20" icon-name="icon-arrow-next" icon-size="0 0 24 24" icon-fill="#718DA8"></svg-icon>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_mini">
                    <div class="profile_blockWidget-bigIcon">
						<svg-icon icon-class="icon icon--inline x15" icon-name="icon-doc" icon-size="0 0 24 24" icon-fill="#718DA8"></svg-icon>
                    </div>
                    <div class="profile_blockWidget-text gorizontal">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Описание торговой<br>стратегии
                        </div>
                        <div class="profile_blockWidget-ico">
                            <a href="http://master.forexinvest.com/files/strategy.pdf" target="_blank">
								<svg-icon icon-class="icon icon--inline x15" icon-name="icon-stash" icon-size="0 0 56 56" icon-fill="#FFFFFF"></svg-icon>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget-chatForms" ref="forms_contact">
                    <div class="contactWidget-title">
                        <div class="contactWidget-titleText" @click="closeCallbackWidget">
							<svg-icon icon-class="icon icon--inline x15" icon-name="icon-phone" icon-size="0 0 48 48" icon-fill="#FFFFFF"></svg-icon>
                                Заказать обратный звонок
                        </div>
                    </div>
                    <div class="contactWidget-title" @click="closeCallbackWidget">
                        <div class="contactWidget-titleText">
							<svg-icon icon-class="icon icon--inline x15" icon-name="icon-coin" icon-size="0 0 42 42" icon-fill="#FFFFFF"></svg-icon>
                            Инвестировать
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_big">
                    <div class="profile_blockWidget-bigIcon">
                        <svg style="width:75px;" viewBox="0 0 24 24">
                            <path fill="#CAE9FF" d="M21,14V4H3V14H21M21,2A2,2 0 0,1 23,4V16A2,2 0 0,1 21,18H14L16,21V22H8V21L10,18H3C1.89,18 1,17.1 1,16V4C1,2.89 1.89,2 3,2H21M4,5H15V10H4V5M16,5H20V7H16V5M20,8V13H16V8H20M4,11H9V13H4V11M10,11H15V13H10V11Z" />
                        </svg>
                    </div>
                    <div class="profile_blockWidget-text">
                        <div class="profile_blockWidget-wrap">
                            <div class="profile_blockWidget-title">
                                Собственный торговый<br>Терминал
                            </div>
                            <div class="profile_blockWidget-subtitle profile_blockWidget-subtitle-link color-green" @click="showScreen">
                                Фотографии терминала
                            </div>
                        </div>
                        <!--<div class="profile_blockWidget-ico">
                            <i class="icon-arrow-move"></i>
                        </div>-->
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_mini">
                    <div class="profile_blockWidget-bigIcon">
                        <svg style="width:30px;height:30px" viewBox="0 0 24 24">
                            <path fill="#CAE9FF" d="M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.89 20.11,3 19,3H5M5,5H19V19H5V5M7,7V9H17V7H7M7,11V13H17V11H7M7,15V17H14V15H7Z" />
                        </svg>
                    </div>
                    <div class="profile_blockWidget-text gorizontal">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Как инвестировать
                        </div>
                        <div class="profile_blockWidget-ico">
                            <a href="http://master.forexinvest.com/files/count.pdf" target="_blank">
								<svg-icon icon-class="icon icon--inline x15" icon-name="icon-stash" icon-size="0 0 42 42" icon-fill="#FFFFFF"></svg-icon>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_mini">
                    <div class="profile_blockWidget-bigIcon">
                        <svg style="width:30px;height:30px" viewBox="0 0 24 24">
                            <path fill="#CAE9FF" d="M5,3C3.89,3 3,3.89 3,5V19C3,20.11 3.89,21 5,21H19C20.11,21 21,20.11 21,19V5C21,3.89 20.11,3 19,3H5M5,5H19V19H5V5M7,7V9H17V7H7M7,11V13H17V11H7M7,15V17H14V15H7Z" />
                        </svg>
                    </div>
                    <div class="profile_blockWidget-text gorizontal">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Соглашение об<br>управлении счётом
                        </div>
                        <div class="profile_blockWidget-ico">
                            <a href="http://master.forexinvest.com/files/agreement.pdf" target="_blank">
								<svg-icon icon-class="icon icon--inline x15" icon-name="icon-stash" icon-size="0 0 42 42" icon-fill="#FFFFFF"></svg-icon>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_vertikal">
                    <div class="profile_blockWidget-text">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Условия инвестирования
                        </div>
                        <div class="profile_blockWidget-subtitle">
                            Мы работаем только с квалифицированными инвесторами, нерезидентами США. Минимальный начальный баланс счета 100 000 USD или эквивалент в Euro, Pounds, Swiss Frank. Управление осуществляется только через провайдеров ликвидности, Вы предоставляете доступ только для управления. Management Fee - 3%, Success Fee - 33,3 %, от HWM, расчеты производятся один раз в месяц.
                        </div>
                    </div>
                    <div class="profile_blockWidget-row">
                        <div class="profile_blockWidget-col profile_blockWidget-col-left">
                            <des icon="icon-info" icon-class="icon icon--inline x15" icon-size="0 0 30 30" :direction="'right'" :width="300" :text="'МАМ счет – дословно “Управляющий несколькими счетами” (Multi Account Manager), т.е— это технология, позволяющая управляющему активами эффективно управлять неограниченным количеством счетов инвестора. МАМ счет это одна из современных форм сотрудничества между управляющим и инвесторами, при которой все средства инвестора хранятся на его персональном счете, а управляющий имеет доступ только для управления.'"></des>
                            <span>Мам счёт</span>
                        </div>
                    </div>
                    <div class="profile_blockWidget-row">
                        <div class="profile_blockWidget-col profile_blockWidget-col-left">
                            <des icon="icon-info" icon-class="icon icon--inline x15" icon-size="0 0 30 30" :direction="'right'" :width="300" :text="'Все средства инвестора хранятся на его персональном торговом счете у провайдера ликвидности Global Markets Group, где инвестор может 24 часа в сутки 7 дней в неделю видеть и контролировать состояние своего счета в личном кабинете предоставленным провайдером и в любой момент может запросить вывод своих средств на расчетный счет в банке, который будет осуществлен в течении 24 часов. Управляющий имеет доступ только для управления торговым счетом Инвестора и заключения торговых сделок от имени Инвестора.'"></des>
                            <span>Доступ к счёту<br>для управления</span>
                        </div>
                        <div class="profile_blockWidget-col">
                            <span>Расчёт один раз в месяц</span>
                            <des icon="icon-info" icon-class="icon icon--inline x15" icon-size="0 0 30 30" :direction="'left'" :width="300" :text="'Комиссия за управление (Management fee) и стимулирующее вознаграждение (success fee) рассчитываются ежемесячно. В течении трех дней с даты окончания каждого месяца Управляющий счетом составляет расчетный документ, где указывает размер обоих вознаграждений, и направляет его Клиенту. Клиент подтверждает, что оба вознаграждения должны быть выплачены в течение пяти календарных дней с даты выставления счета. Все эти платежи  должны переводиться на счет Управляющего счетом. Банковские реквизиты указываются в расчетном документе, направляемом Управляющим счетом.'"></des>
                        </div>
                    </div>
                    <div class="profile_blockWidget-row">
                        <div class="profile_blockWidget-col profile_blockWidget-col-left">
                            <des icon="icon-info" icon-class="icon icon--inline x15" icon-size="0 0 30 30" :direction="'right'" :width="300" :text="'MANAGEMENT FEE от AUM - плата за управление активами в размере 3,0 % годовых от суммы чистых активов под управлением.'"></des>
                            <span>Management FEE 3%<br>годовых от AUM</span>
                        </div>
                        <div class="profile_blockWidget-col">
                            <span>Success FEE от 33.3% от<br>суммы превышающей HWM</span>
                            <des icon="icon-info" icon-class="icon icon--inline x15" icon-size="0 0 30 30" :direction="'left'" :width="300" :text="'SUCCESS FEE от HWM - стимулирующее вознаграждение в размере 33,3 % от прибыли.'"></des>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget profile_blockWidget_vertikal">
                    <div class="profile_blockWidget-text">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom">
                            Прогнозируемая доходность
                        </div>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                            15-20% годовых 5-7% волатильность
                        </div>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                            25-35% годовых 10-12% волатильность
                        </div>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                            40-55% годовых 15-20% волатильность
                        </div>
                    </div>
                    <div class="profile_blockWidget-text profile_blockWidget-text_prognosis">
                        <div class="profile_blockWidget-title profile_blockWidget-title_noBottom profile_blockWidget-title_prognosis">
                            50+ % годовых 25-30% волатильность
                        </div>
                    </div>
                </div>
            </scrollbar>
        </div>
        <div class= "grid__main-content">
            <div>
                <div class="profile_blockWidget-header">
                    <div class="profile_blockWidget-trader">
                        <div class="profile_blockWidget-traderAva f-ava f-ava--big">
                            <img src="../assets/img/adenisov.png" class="f-ava__img">
                        </div>
                        <div class="profile_blockWidget-traderName">
                            <div class="profile_blockWidget-name">
                                Алексей Денисов
                            </div>
                            <div class="profile_blockWidget-status">
                                Трейдер, управляющий ДУ
                            </div>
                        </div>
                    </div>
                    <div class="profile_blockWidget-traderSkils">
                        <div class="profile_blockWidget-traderSkils-wrap">
                           <ul class="profile_blockWidget-traderSkilsUl">
                               <li>Аттестованный специалист финансового рынка</li>
                               <li>Обладатель авторской<br>торговой системы</li>
                           </ul>
                           <ul class="profile_blockWidget-traderSkilsUl">
                               <li>Разработал собственный<br>торговый терминал</li>
                               <li>22 года на финансовом<br>рынке</li>
                           </ul>
                        </div>
                    </div>
                </div>
                <div class="profile_blockWidget-center">
                    <scrollbar class="profile_blockWidget-profitWidget">
                        <income-widgets  v-for="(item,index) in profitWidgets" :key="index" :incomeTitle="item.title"
                            :type="item.type" :chart="item.chart" :param="item.param">
                        </income-widgets>
                        <div class="profile_blockWidget profile_blockWidget-profitDeals">
                            <div class="profile_blockWidget-profitDeals_wrapData">
                                <div class="profile_blockWidget-profitDeals-title">
                                    % успешных сделок
                                </div>
                            </div>
                            <div class="profile_blockWidget-profitDeals-chart">
                                <round></round>
                            </div>
                        </div>
                        <stat-table></stat-table>
                    </scrollbar>
                    <scrollbar class="profile_blockWidget-chartWrap">
                        <div class="profile_blockWidget-chart" style="height:680px;">
                            <strategy
                                :fullStatus="false"
                                :mini="true"
                            >
                            </strategy>
                        </div>
                        <div class="profile_blockWidget-chart">
                            <equtiChart
                                :fullStatus="false"
                                :mini="true"
                                :noti="false"
                            >
                            </equtiChart>
                        </div>
                        <div class="profile_blockWidget-chartPrognosis">
                            <div class="profile_blockWidget-chartPrognosis_item">
                                <chart-prognosis
                                    :period="'sison'"
                                    :percent="96"
                                    :title="'3 месяца'">
                                </chart-prognosis>
                            </div>
                            <div class="profile_blockWidget-chartPrognosis_item">
                                <chart-prognosis
                                    :period="'sixmonth'"
                                    :percent="91"
                                    :title="'6 месяцев'">
                                </chart-prognosis>
                            </div>
                        </div>
                    </scrollbar>
                </div>
            </div>
        </div>
        <div class="grid__chat">
            <div class="profile_blockWidget profile_blockWidget-chat">
                <div class="profile_blockWidget-chatWidget">
                    <chat-live :heightBlock="heightContactBlock"></chat-live>
                </div>
            </div>
        </div>
        <div class="gallery-overlay" v-show="showGallery">
            <div class="gallery">
                <div @click="showScreen" class="gallery-closeIcon">
					<svg-icon icon-class="icon icon--inline" icon-name="icon-close" icon-size="0 0 32 32" icon-fill="#FFFFFF"></svg-icon>
                </div>
                <div class="gallery-row">
                    <div class="gallery-item" v-for="(item,index) in galleryItems" :key="index">
                        <img :src="item.src" @click="showItemGallery(index)">
                    </div>
                </div>
            </div>
        </div>
        <div class="gallery-overlaySlider" v-if="itemGallery">
            <div class="gallery-sliderItem">
                <div class="gallery-sliderPrevIcon" @click="prevSlide()">
                    <svg style="width:50px;height:50px" viewBox="0 0 24 24">
                        <path fill="#fff" d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" />
                    </svg>
                </div>
                <div class="gallery-sliderImg">
                    <div class="gallery-closeIcon" @click="closeSlide">
						<svg-icon icon-class="icon icon--inline" icon-name="icon-close" icon-size="0 0 32 32" icon-fill="#FFFFFF"></svg-icon>
                    </div>
                    <img :src="getActiveSlide.src">
                </div>
                <div class="gallery=sliderNextIcon" @click="nextSlide()">
                    <svg style="width:50px;height:50px" viewBox="0 0 24 24">
                        <path fill="#fff" d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    </svg>
                </div>
            </div>
        </div>
        <div v-if="showCallbackWidget" class="callBackWidget">
            <callback-widget  @closeWidget="closeCallbackWidget"/>
        </div>
    </div>
</template>

<script>
import LiveChat from './chat/chat-live-trader';
import CallBackWidget from './ui-components/callback-widget';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import IncomeWidget from './profitability/leftNavigator/income-widget/income-widget';
import ProfitStrategy from './profitability/chartsForTabs/pofitInPercent/sig-profit-chart-strategy-widget';
import PrognosisChart from "./profitability/sig-profitability-chart-prognosis";
import chartRound from "./ui-components/persent-of-close-positions";
import { BulmaAccordion, BulmaAccordionItem } from 'vue-bulma-accordion';
import BalanceEquityCharts from "./profitability/sig-chart-profit-widget";
import StatTable from "./profitability/sig-profitability-stat-table";
import Description from "./ui-components/description";
import svgIcon from './ui-components/svg-icon';
import { setTimeout } from 'timers';
	export default {
		components: {
            "chat-live":LiveChat,
            "scrollbar":VuePerfectScrollbar,
            "income-widgets":IncomeWidget,
            "strategy": ProfitStrategy,
            "chart-prognosis":PrognosisChart,
            "round":chartRound,
            "accordion-item":BulmaAccordionItem,
            "accordion":BulmaAccordion,
            "equtiChart":BalanceEquityCharts,
            "stat-table":StatTable,
            "des":Description,
            "callback-widget":CallBackWidget,
			"svg-icon":svgIcon
        },
		props: [],
		data() {
			return {
                contact:true,
                invest:true,
                call:false,
                showCallbackWidget:false,
				profitWidgets:[ {
                title:'Баланс',
                type: 'balance',
                chart: true,
                param: 'bal',
            },
            {
                title:'Средства',
                type: 'equity',
                chart: true,
                param: 'eq'
            },
            {
                title:'Чистая прибыль',
                type:'plAbs',
                chart: true,
                param: 'plAbs'
            },
            {
                title:'Текущий доход',
                type:'plCur',
                chart: true,
                param:'plCur'
            },
            {
                title:'Изменения за сутки',
                type:'changeDay',
                chart: true,
                param:'changeDay'
            }
            ],
            heightContactBlock:null,
            galleryItems:[{
                src: require('../assets/img/2.png')
            },
            {
                src: require('../assets/img/3.png')
            },
            {
                src: require('../assets/img/4.png')
            },
            {
                src: require('../assets/img/5.png')
            },
            {
                src: require('../assets/img/6.png')
            },
            {
                src: require('../assets/img/7.png')
            },
            {
                src: require('../assets/img/8.png')
            },
            {
                src: require('../assets/img/9.png')
            },
            {
                src: require('../assets/img/10.png')
            }],
            activeSlide:{src:null,index:0},
            showGallery:false,
            itemGallery:false,
            };
		},
		computed: {
			getHeightBlock() {
                 return this.heightContactBlock;
            },
            getActiveSlide() {
                return this.activeSlide;
            }
 		},
		methods: {
			showContact() {
                this.contact = !this.contact;
            },
            showInvest() {
                this.invest = !this.invest;
            },
            showCall() {
                this.call = !this.call;
            },
            showScreen() {
                this.showGallery = !this.showGallery;
            },
            closeCallbackWidget() {
                this.showCallbackWidget = !this.showCallbackWidget
            },
            nextSlide() {
                this.activeSlide.index++;
                if(this.activeSlide.index >= this.galleryItems.length) {
                    this.activeSlide.src = this.galleryItems[0].src;
                    this.activeSlide.index = 0;
                }
                this.activeSlide.src = this.galleryItems[this.activeSlide.index].src;
            },
            prevSlide() {
                this.activeSlide.index--;
                if(this.activeSlide.index < 0) {
                    this.activeSlide.src = this.galleryItems[this.galleryItems.length - 1].src;
                    this.activeSlide.index = this.galleryItems.length - 1;
                }
                this.activeSlide.src = this.galleryItems[this.activeSlide.index].src;
            },
            showItemGallery(itemIndex) {
                this.activeSlide.src = this.galleryItems[itemIndex].src;
                this.activeSlide.index = itemIndex;
                this.itemGallery = !this.itemGallery;

            },
            closeSlide() {
                this.itemGallery = !this.itemGallery;
            },
            changeHeight() {
                setTimeout(()=>{
                     let heightBlock = this.$refs.forms_contact.offsetHeight;
                    this.heightContactBlock = heightBlock;
                },910)

            }
        },
        mounted() {
            let heightBlock = this.$refs.forms_contact.offsetHeight;
            this.heightContactBlock = heightBlock;
        }

	};
</script>
<style lang="less" scoped>
.profile_blockWidget {
    display: flex;
    width: 360px;
    background: #3D536B;
    margin-bottom: 4px;
    &-image {
        display: flex;
        border-bottom: solid 1px #293546;
        height: 179px;
        display: flex;
        align-items: center;
        padding-left: 12px;
    }
    &-imageItem {
        height: 155px;
        width: 109px;
        margin-right: 12px;
    }
    &-header {
      background: #3D536B;
      width: 100%;
      display: flex;
      height: 172px;
      padding: 0 23px 0 23px;
      box-sizing: border-box;
    }
    &-center {
        display: flex;
        margin-top: 4px;
        height: calc(100vh - 275px);
        overflow: hidden;
        //margin-bottom: 4px;
    }
    &-chat {
        display: flex;
        flex-direction: column;
        min-height: 100%;
        overflow: hidden;
        background: #293546;
    }
    &-chatWidget {
        //flex-grow: 1;
        //max-height: 100%;
        //flex-basis: 100%;
    }
    &-chatForms {
        //flex-grow: 1;
        //flex-basis: 100%;
    }
    &-profitDeals {
        display: flex;
        justify-content: space-between;
        &_wrapData {
            padding: 8px 16px;
        }
        &-title {
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 2.18;
            letter-spacing: .4px;
            text-transform: uppercase;
            color: #fff;
            margin-top: 4px;
        }
        &-chart {
            flex-grow: 1;
            max-width: 180px;
            padding: 8px 16px;
            display: flex;
            justify-content: flex-end;
        }
    }
    &-profitWidget {
        min-width: 360px;
        height: calc(100vh - 264px);
        overflow: auto;
    }
    &-chart {
        max-width: 100%;
        height: 480px;
        flex-grow: 1;
        @media (max-width: 1690px) {
            height: 404px;
        }
        @media (min-width: 1930px) {
            height: calc(100vh - 804px);
        }
        &:first-child {
            margin-bottom: 3px;
        }
    }
    &-chartWrap {
        flex-grow: 1;
        margin-left: 4px;
        height: calc(100vh - 275px);
        overflow: auto;
    }
    &-chartPrognosis {
        display: flex;
        width: 100%;
        max-height: 245px;
        border-top: solid #293546 4px;
        &_item {
            flex-basis: 50%;
            flex-grow: 1;
            height: 245px;
            &:first-child {
                border-right: solid #293546 4px;
            }
        }
    }
    &-trader {
        align-items: center;
        display: flex;
        width: 45%;
        padding-right: 40px;
        box-sizing: border-box;
        justify-content: space-between;
        border-right: solid #293546 1px;
        @media (max-width: 1690px) {
            width: 50%;
        }

    }
    &-traderAva {

        @media (max-width: 1690px) {
            margin-right: 12px;
        }
    }
    &-traderName {

    }
    &-name {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 22px;
        line-height: 20px;
        letter-spacing: 0.4px;
        color: #FFFFFF;
        margin-bottom: 20px;
        @media (max-width: 1690px) {
            font-size: 18px;
        }
    }
    &-status {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 17px;
        line-height: 16px;
        letter-spacing: 0.4px;
        color: #ADC4E1;
        @media (max-width: 1690px) {
             font-size: 14px;
        }
    }
    &-traderSkils {
        display: flex;
        flex-grow: 1;
        align-items: center;
        justify-content: center;
        &-wrap {
            display: flex;
            justify-content: space-between;
            max-width: 100%;
            padding-left: 23px;
        }
    }
    &-traderSkilsUl {
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        /* or 143% */
        letter-spacing: 0.4px;
        max-width: 45%;
        margin-left: 23px;
    }
    &_vertikal {
        display: block;
    }
    &_big {
        height: 120px;
        &-column {
            flex-direction: column;
        }
    }
    &_mini {
        height: 70px;
    }
    &-text {
        padding: 12px;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        &_prognosis {
           border-top: 1px solid #293546;
        }
    }
    &-row {
        width: 100%;
        display: flex;
        justify-content: space-between;
        border-top: 1px solid #293546;
    }
    &-col {
        width: 50%;
        flex-grow: 1;
        padding: 12px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-right: 1px solid #293546;
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 10px;
        line-height: 14px;
        /* identical to box height, or 140% */
        letter-spacing: 0.4px;
        color: #FFFFFF;
        &-left {
            justify-content: flex-start;
            span:last-child {
                margin-left: 6px;
            }
        }
        &:last-child {
           border-right:none;
        }
    }
    &-title {
        font-family: Arimo;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 20px;
        /* identical to box height, or 167% */
        letter-spacing: 0.4px;
        text-transform: uppercase;
        color: #FFFFFF;
        margin-bottom: 12px;
        &_noBottom {
            margin-bottom: 0;
        }
        &_prognosis {
            font-family: Arimo;
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            /* or 267% */
            letter-spacing: 0.4px;
            text-transform: uppercase;
            color: #00FFD0;
        }
    }
    &-subtitle {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 13px;
        line-height: 15px;
        color: #ADC4E1;
        a {
           color: #ADC4E1;
        }
        &-link {
            text-transform: uppercase;
            cursor: pointer;
        }
    }
    &-bigIcon {
        padding: 20px;
        border-right: 1px #293546 solid;
    }
    &-ico {
        color:#718DA8;
        cursor: pointer;
    }
}
.contactWidget {
    &-title {
        padding: 12px;
        background: #3D536B;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        z-index: 1;
        margin-bottom: 3px;
        //border-bottom: #293546  1px solid;
        i {
            color:#718DA8;
            cursor: pointer;
        }
    }
    &-titleText {
        display: flex;
        align-items: center;
        i {
            color:#fff;
            font-size: 24px;
            margin-right: 8px;
            margin-bottom: -4px;
        }
    }
}
input[type="text"]::placeholder { color: #CCE0F8; }
.black-overlay {
    background: #293546 !important;
}
.gorizontal {
    flex-direction: row;
    width: 100%;
    align-items: center;
}
.vertical {
    flex-direction: column
}
.profile-scroll {
    max-height: 100%;
}
ul.profile_blockWidget-traderSkilsUl {
    list-style: disc outside !important;
}
ul.profile_blockWidget-traderSkilsUl > li:first-child {
    margin-bottom: 30px;
}
.gallery {
    width: 80vw;
    &-sliderItem {
      width: 80vw;
      display: flex;
      align-items: center;
    }
    &-closeIcon {
        width: 100%;
        text-align: right;
        margin-bottom: 23px;
        font-size: 23px;
        cursor: pointer;
    }
    &-overlay {
        position: fixed;
        background: rgba(0,0,0,0.9);
        width: 100vw;
        height: 100vh;
        top:0;
        right: 0;
        z-index: 6;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &-overlaySlider {
        position: fixed;
        background: rgba(0,0,0,0.9);
        width: 100vw;
        height: 100vh;
        top:0;
        right: 0;
        z-index: 7;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    &-row {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
    }
    &-item {
        flex-grow: 1;
        flex-basis: 33%;
    }
}

.callBackWidget {
    width: calc(100vw - 75px);
    height: calc(100vh - 98px);
    position: absolute;
    background: rgba(0,0,0,0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 7;
}
</style>
